import React from 'react';
import { PdaMessage, PdaLog as PDALog } from './pda-log.js';

interface PdaLogProps {
  messages: PdaMessage[];
  zone: string;
}

export const PdaLog: React.FC<PdaLogProps> = ({ messages, zone }) => {
  React.useLayoutEffect(() => PDALog.register(), []);
  return (
    // @ts-ignore
    <pda-log
      messages={messages}
      zone={zone}
    />
  );
};
